'use client';

import { usePrevious } from './usePrevious';

export const useInspectDeps = (deps: any[], callback?: (changedDeps: any[]) => void) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const changedDeps = deps.map((d, i) => [i, usePrevious(d), d]).filter(d => d[2] !== d[1]);
  callback?.(changedDeps);
};

export default useInspectDeps;
